module.exports = __webpack_public_path__ + "static/img/faceGif.f8a071a6.gif";